import { CreateUpdateMerchantFormValues } from "../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"

export const defaultMerchantInitialValues: CreateUpdateMerchantFormValues = {
    caseNumber: "",
    name: "",
    address: {
        street: "",
        streetNumber: "",
        postalCode: "",
        city: "",
        countryCode: "DK",
    },
    contactDetails: {
        name: "",
        phoneNumber: "",
        email: "",
    },
    openingHours: [],
    isActive: true,
    acquiringDetails: {},
}
